import { LogOut } from 'lucide-react';
import { useMe, useSignOut } from '../../lib/session';
import { Button, Card, Logo, Spinner } from '../../ui';

const ROLE_LABEL: Record<string, string> = {
  teacher: 'Teacher',
  principal: 'Principal',
  lab_admin: 'Lab admin',
  platform_admin: 'Platform admin',
};

export function StaffHomePage() {
  const me = useMe();
  const signOut = useSignOut();
  const m = me.data;
  if (!m || m.kind !== 'staff' || m.stage === 'mfa') return <Spinner />;
  const ctx = m.active ? m.contexts.find((c) => c.tenantId === m.active?.tenantId) : null;

  return (
    <div className="min-h-dvh bg-canvas-staff">
      <header className="border-b border-line bg-surface">
        <div className="mx-auto flex h-16 max-w-6xl items-center gap-4 px-4">
          <Logo className="h-7" />
          <span className="hidden text-sm text-muted sm:inline">
            {ctx?.tenantName}
            {m.active && ` · ${ROLE_LABEL[m.active.role] ?? m.active.role}`}
          </span>
          <Button variant="ghost" className="ml-auto" onClick={() => void signOut()} icon={<LogOut className="size-4" aria-hidden />}>
            Sign out
          </Button>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-4 py-10">
        <h1 className="text-3xl font-extrabold">Welcome, {m.user.displayName}</h1>
        <Card className="mt-6 p-6">
          <p className="font-semibold">Your workspace is being built.</p>
          <p className="mt-1 text-muted">Class overview, live lab view and reports arrive in the next release.</p>
        </Card>
      </main>
    </div>
  );
}
